import request from '@/utils/home/logs' 

export function getlogslist(data) { // 获取日志list
  console.log(data)
    return request({
      url: '/api/logs/log/query',
      method: 'post',
      data
    })
  }